module.exports = __webpack_public_path__ + "img/lose.cf83435b.png";